// extracted by mini-css-extract-plugin
module.exports = {"myJohnLewisIcon":"decision-tree-icon_myJohnLewisIcon__Xsq9W","icon":"decision-tree-icon_icon___4k_d"};